import styled from "styled-components";

export const StyledWrapper = styled.div`
  margin-top: 28px;
  width: 208px;
  flex: 0 0 auto;

  a {
    padding: 0;
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.CommentsBody}
    background-color: transparent;
    border: 0;

    &:active,
    &:focus,
    &:hover {
      cursor: pointer;
    }
  }

  .menu {
    margin: 0;
    padding: 0;
    list-style-type: none;

    .menu-item {
      margin: 4px 0;
      padding: 14px 16px 14px 24px;
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.CommentsBody}
      border-radius: 4px;
      cursor: default;
      display: flex;
      justify-content: space-between;

      svg {
        margin: -6px -8px;
        padding: 4px;
        background-color: ${({ theme }) =>
          theme.colors.primaryBackgroundSelected};
        border-radius: 2px;
        box-sizing: content-box;
      }

      &.active {
        background-color: ${({ theme }) => theme.colors.primaryRulerTint15};

        a {
          color: ${({ theme }) => theme.colors.primaryBackgroundSelected};
          ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopyBold}

          &:active,
          &:focus,
          &:hover {
            cursor: default;
            text-decoration: none;
          }
        }
      }
    }
  }

  .submenu {
    margin: 16px 0 16px 24px;
    border-left: 1px solid ${({ theme }) => theme.colors.primaryRulerTint50};

    &.closed {
      margin: 0;
      height: 0;
      overflow: hidden;
    }

    .submenu-item {
      margin: 4px 0;
      padding: 14px 16px;
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.CommentsBody}
      border-radius: 4px;

      .item-marker {
        position: relative;
        top: -2px;
        left: -18px;
        width: 3px;
        height: 24px;
        background-color: ${({ theme }) =>
          theme.colors.primaryBackgroundSelected};
        border-radius: 2px;
        float: left;
        visibility: hidden;
      }

      &.active {
        background-color: transparent;

        a {
          color: ${({ theme }) => theme.colors.primaryTextSelected};
          ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopyBold}

          &:active,
          &:focus,
          &:hover {
            cursor: default;
            text-decoration: none;
          }
        }

        .item-marker {
          visibility: visible;
        }
      }

      &:first-child {
        margin-top: 0;
        padding-top: 2px;
      }

      &:last-child {
        margin-bottom: 0;
        padding-bottom: 2px;
      }
    }
  }

  *:focus-visible {
    outline: none;
  }
`;
